export default "__VITE_ASSET__4a2d605d__$_?nuxt_component=async__"